import {ThemeProvider} from '@deere/fuel-react';
import React from 'react';
import ReactDOM from 'react-dom';
import {Helmet, HelmetProvider} from 'react-helmet-async';
import {BrowserRouter as Router} from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
    <React.StrictMode>
        {/* HelmetProvider allows access to the Head of the page */}
        <HelmetProvider>
            <Helmet>
                <meta charSet='utf-8'/>
                <meta
                    content='#ffffff'
                    name='msapplication-TileColor'
                />
                <meta
                    content='#ffffff'
                    name='theme-color'
                />
                <meta
                    content='width=device-width, initial-scale=1'
                    name='viewport'
                />
                <link
                    href='https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/green-favicon/apple-touch-icon.png'
                    rel='apple-touch-icon'
                    sizes='180x180'
                />
                <link
                    href='https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/green-favicon/favicon-32x32.png'
                    rel='icon'
                    sizes='32x32'
                    type='image/png'
                />
                <link
                    href='https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/green-favicon/favicon-16x16.png'
                    rel='icon'
                    sizes='16x16'
                    type='image/png'
                />
                <link
                    href='https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/green-favicon/site.webmanifest'
                    rel='manifest'
                />
                <link
                    color='#367c2b'
                    href='https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/green-favicon/safari-pinned-tab.svg'
                    rel='mask-icon'
                />
                <link
                    href='https://cdn.ux.deere.com'
                    rel='preconnect'
                />
                <link
                    href='https://cdn.ux.deere.com/brand-foundations/1.3.1/typography/fonts.css'
                    rel='stylesheet'
                />
            </Helmet>
            <ThemeProvider includeFonts={false}>
                <Router>
                    <App/>
                </Router>
            </ThemeProvider>
        </HelmetProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
